export const isPointNearPoint = (p1, p2, threshold = 15) => {
  const dx = p1.x - p2.x;
  const dy = p1.y - p2.y;
  return Math.hypot(dx, dy) < threshold;
};

export const isPointOnLine = (point, lineStart, lineEnd, threshold = 10) => {
  const A = point.x - lineStart.x;
  const B = point.y - lineStart.y;
  const C = lineEnd.x - lineStart.x;
  const D = lineEnd.y - lineStart.y;
  const dot = A * C + B * D;
  const lenSq = C * C + D * D;
  if (lenSq === 0) return false;
  const param = dot / lenSq;
  if (param < 0 || param > 1) return false;
  const xx = lineStart.x + param * C;
  const yy = lineStart.y + param * D;
  const dx = point.x - xx;
  const dy = point.y - yy;
  return Math.hypot(dx, dy) < threshold;
};

export const isPointInPolygon = (point, polygon) => {
  if (polygon.length < 3) return false;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    if (
      polygon[i].y > point.y !== polygon[j].y > point.y &&
      point.x <
        ((polygon[j].x - polygon[i].x) * (point.y - polygon[i].y)) /
          (polygon[j].y - polygon[i].y) +
          polygon[i].x
    ) {
      inside = !inside;
    }
  }
  return inside;
};

export const isPointOnPolygonEdge = (point, polygon, threshold = 10) => {
  for (let i = 0; i < polygon.length; i++) {
    const j = (i + 1) % polygon.length;
    if (isPointOnLine(point, polygon[i], polygon[j], threshold)) return true;
  }
  return false;
};

export const getTextBounds = (annotation) => {
  return {
    x: annotation.position.x,
    y: annotation.position.y,
    width: annotation.width,
    height: annotation.height,
  };
};

export const getTextResizeHandle = (point, annotation) => {
  const bounds = getTextBounds(annotation);
  const margin = 8;
  const handles = [
    { x: bounds.x, y: bounds.y, type: "nw" },
    { x: bounds.x + bounds.width / 2, y: bounds.y, type: "n" },
    { x: bounds.x + bounds.width, y: bounds.y, type: "ne" },
    { x: bounds.x + bounds.width, y: bounds.y + bounds.height / 2, type: "e" },
    { x: bounds.x + bounds.width, y: bounds.y + bounds.height, type: "se" },
    { x: bounds.x + bounds.width / 2, y: bounds.y + bounds.height, type: "s" },
    { x: bounds.x, y: bounds.y + bounds.height, type: "sw" },
    { x: bounds.x, y: bounds.y + bounds.height / 2, type: "w" },
  ];
  for (const handle of handles) {
    if (isPointNearPoint(point, { x: handle.x, y: handle.y }, margin)) {
      return handle.type;
    }
  }
  return null;
};

export const isPointNearGuideline = (point, guideline, threshold = 10) => {
  if (guideline.type === "vertical") {
    return Math.abs(point.x - guideline.position) < threshold;
  }
  return Math.abs(point.y - guideline.position) < threshold;
};
